export const USER_ACCOUNT_ROLES = ['admin', 'annotator'] as const;

export type UserAccountRole = (typeof USER_ACCOUNT_ROLES)[number];

export interface PrivacyPolicyAcceptanceReadModel {
  version: string;
  locale: string;
  displayUrl: string;
  mediaType: 'text/html' | 'application/pdf';
  contentHash: string;
  acceptedAt: string;
}

export interface UserAccount {
  uid: string;
  email: string | null;
  displayName: string | null;
  disabled: boolean;
  emailVerified: boolean;
  createdAt: string;
  lastSignedInAt: string | null;
  roles: UserAccountRole[];
  privacyPolicyAcceptance?: PrivacyPolicyAcceptanceReadModel | null;
}

export const hasUserAccountRole = (user: UserAccount, role: UserAccountRole): boolean =>
  user.roles.includes(role);

export const hasBackofficeRoleInRoles = (roles: ReadonlyArray<UserAccountRole>): boolean =>
  roles.some((role) => USER_ACCOUNT_ROLES.includes(role));

export const hasBackofficeRole = (user: UserAccount): boolean =>
  hasBackofficeRoleInRoles(user.roles);

export const canAccessBackoffice = (user: UserAccount): boolean =>
  !user.disabled && hasBackofficeRole(user);

export const wouldSelfDemoteBackofficeAccess = (
  user: UserAccount,
  selectedRoles: ReadonlyArray<UserAccountRole>
): boolean => hasBackofficeRole(user) && !hasBackofficeRoleInRoles(selectedRoles);

export const isAppAccessOnly = (user: UserAccount): boolean => user.roles.length === 0;
